import { useDynamicGrid } from '~/app/lib/redux/selectors/dynamic-grid-selector';
import { baseSegmentAnalytics } from '~/app/lib/utils';
import { segmentImpressionId } from '~/app/lib/segment-analytics';
import { FinishType } from '@nerdwallet/react-apply-now';
import { useAnalyticsPageView } from '@nerdwallet/seo-analytics';
import { usePathname } from 'next/navigation';
import SegmentImpression from '~/app/components/segment-impression';
import appConfig from '@nerdwallet/app-config';

const eventNameMap = {
  skuViewed: 'SKU Viewed',
  viewed: 'Element Viewed',
};

export const SegmentTrackingWrapper = ({
  children,
  eventName,
  marketplaceOfferId,
  impressionSection,
  impressionPosition,
  entityName,
  location,
  subLocation,
  className,
}: {
  children: React.ReactNode;
  eventName?: string;
  marketplaceOfferId?: string;
  impressionSection?: string;
  impressionPosition?: string;
  entityName?: string;
  location?: string;
  subLocation?: string;
  className?: string;
}) => {
  const { marketplaceOffers } = useDynamicGrid();
  const marketplaceOffer = marketplaceOffers?.find(
    (offer: any) => offer?.id === marketplaceOfferId
  );

  const pathname = usePathname();
  const { pageViewId } = useAnalyticsPageView();

  const skuViewedProps = {
    sku_id: marketplaceOffer?.id ?? entityName,
    sku_level: marketplaceOffer?.productType ?? entityName,
    sku_name: marketplaceOffer?.name ?? entityName,
    sku_source: 'marketplace',
    sku_product_type: marketplaceOffer?.productType ?? 'cta_button',
    sku_impression_id: segmentImpressionId,
    monetizable: 'YES_ASSUMED',
  };
  const locationProps = {
    ...(location && { location }),
    ...(subLocation && { sub_location: subLocation }),
  };

  const optionalImpressionProps = {
    ...(impressionSection && { impression_section: impressionSection }),
    ...(impressionPosition && { impression_position: impressionPosition }),
  };

  const impressionViewProps = {
    ...baseSegmentAnalytics,
    ...(eventName === 'skuViewed' && skuViewedProps),
    ...locationProps,
    ...optionalImpressionProps,
    entity_name: entityName ?? '',
    impression_id: segmentImpressionId,
    impression_page_url: pathname,
    entry_point_page_name: pathname,
    impression_pageview_id: pageViewId,
    finish_type: FinishType.EXTERNAL_APPLICATION,
    // eslint-disable-next-line no-underscore-dangle
    calling_deployable_name: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    calling_deployable_version: appConfig?._meta?.version,
  };

  const eventNameValue =
    eventNameMap[eventName as keyof typeof eventNameMap] || 'SKU Viewed';

  return (
    <SegmentImpression
      eventProps={impressionViewProps}
      eventName={eventNameValue}
      className={className}
    >
      {children}
    </SegmentImpression>
  );
};
